import Vue from 'vue'

Vue.component('SubscribePromo', {
  template: '#subscribe-promo',
  created () {
    console.log('Has inline subscribe');
    
    this.$root.hasInlineSubscribe = true;
  }
})